import { render, staticRenderFns } from "./AgendaPro.vue?vue&type=template&id=d18e8616"
import script from "./AgendaPro.vue?vue&type=script&lang=js"
export * from "./AgendaPro.vue?vue&type=script&lang=js"
import style0 from "./AgendaPro.vue?vue&type=style&index=0&id=d18e8616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports